/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-console */
import crypto from 'crypto';
import { decryptData } from '../api/Customer';
import { RecordCheck } from '../types/types';

const getData = (key: string, iv: string, data: string) => {
  const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
  let result = decipher.update(data, 'hex', 'utf8');
  result += decipher.final('utf8');
  return result;
};

export const getCustomerInformation = async (customerDetails: any) => {
  const { dateOfBirthEnc, taxIdEnc, firstName, lastName } = customerDetails;

  const customerInfo: {
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string;
    ssn?: string;
  } = {
    firstName,
    lastName,
  };

  if (!dateOfBirthEnc && !taxIdEnc) {
    return customerInfo;
  }

  try {
    const encryptKey = crypto.randomBytes(16).toString('hex');
    const ivKey = crypto.randomBytes(8).toString('hex');

    const response = await decryptData({
      decryptData: {
        dateOfBirth: dateOfBirthEnc,
        taxId: taxIdEnc,
      },
      encryptKey: encryptKey,
      ivKey: ivKey,
    });

    if (response && response?.decryptData) {
      const decrypted = response.decryptData;
      customerInfo.dateOfBirth = decrypted.dateOfBirth
        ? getData(encryptKey, ivKey, decrypted.dateOfBirth)
        : '';
      customerInfo.ssn = decrypted.taxId
        ? getData(encryptKey, ivKey, decrypted.taxId)
        : '';
    }
  } catch (error) {
    console.error('Error decrypting customer data:', error);
  }
  console.log('customerInfo', customerInfo);
  return customerInfo;
};

export const transformRecordCheckResponse = (rawData: any): RecordCheck => ({
  transactionDate: rawData.transactionDate,
  transactionId: rawData.transactionId,
  tloCustomerId: rawData.tloCustomerId || '',
  references: rawData.references,
  employers: rawData.employers,
  addresses: rawData.addresses,
  emails: rawData.emails,
  phones: rawData.phones,
});

export const sortData = (data: any[], key: string, order: 'asc' | 'desc') => {
  return [...data].sort((a, b) => {
    if (a[key] < b[key]) return order === 'asc' ? -1 : 1;
    if (a[key] > b[key]) return order === 'asc' ? 1 : -1;
    return 0;
  });
};
